import axios from 'axios';

export const formatContent = async (content, prompt, settings) => {
  const { apiKey, apiUrl, model, temperature, maxTokens } = settings;

  if (!apiKey || !apiUrl || !model) {
    throw new Error('API settings are incomplete. Please check your settings.');
  }

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${apiKey}`
  };

  const data = {
    model: model,
    messages: [
      {
        role: "system",
        content: prompt
      },
      {
        role: "user",
        content: content
      }
    ],
    temperature: parseFloat(temperature) || 0.2,
    max_tokens: parseInt(maxTokens) || 8000
  };

  try {
    const response = await axios.post(apiUrl, data, { headers });
    
    if (response.data && response.data.choices && response.data.choices.length > 0) {
      return response.data.choices[0].message.content.trim();
    } else {
      throw new Error('Unexpected API response format');
    }
  } catch (error) {
    console.error('OpenAI API Error:', error);
    
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      const status = error.response.status;
      const data = error.response.data;
      
      if (status === 401) {
        throw new Error('Invalid API key. Please check your OpenAI API key.');
      } else if (status === 429) {
        throw new Error('Rate limit exceeded. Please try again later.');
      } else if (data && data.error && data.error.message) {
        throw new Error(data.error.message);
      } else {
        throw new Error(`API error: ${status}`);
      }
    } else if (error.request) {
      // The request was made but no response was received
      throw new Error('No response from OpenAI API. Please check your internet connection or API URL.');
    } else {
      // Something happened in setting up the request that triggered an Error
      throw new Error(`Error: ${error.message}`);
    }
  }
}; 